module.exports = "/_next/static/images/bf88073187b996b0d04af4e8c43ed107-clips@desktop1366.jpg.webp";